import apiClient from './apiClient'


const getLabels = (tenant) => {
  return apiClient.get(`/${tenant}/Contact/Labels`)
}

const createLabel = (tenant, label) => {
  return apiClient.post(`/${tenant}/Contact/Label`, label)
}

const updateLabel = (tenant, id, label) => {
  return apiClient.put(`/${tenant}/Contact/Label/${id}`, label)
}

const deleteLabel = (tenant, id) => {
  return apiClient.delete(`/${tenant}/Contact/Label/${id}`)
}


export default {
  getLabels,
  createLabel,
  updateLabel,
  deleteLabel
}
